import { useEffect, useState } from 'react';
import { getSyncStatus } from '../api.js';
import { ribbonMessage } from '../lib/syncHealth.js';

export default function SyncRibbon(): JSX.Element | null {
  const [message, setMessage] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    getSyncStatus()
      .then((r) => {
        if (alive) setMessage(ribbonMessage(r.sources));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  if (!message) return null;
  return (
    <div className="ribbon ribbon--warn" role="status">
      {message}
    </div>
  );
}
